<template>
    <span>
        <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col sm="10">
                    <h3>Cadastrar Conteúdo Informativo</h3>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
             <b-form v-on:submit.prevent="onSubmit">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Título do arquivo: *">
                  <b-input-group class="mb-6">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Título"
                                  autocomplete="cpf"
                                  v-model="$v.form.titulo.$model"
                                  :state="chkState('titulo')"
                                  autofocus/>
                    <b-form-invalid-feedback id="input1LiveFeedback1">Título é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
               <b-col cols="12">
                <label>Descrição: *</label>
                <b-form-textarea id="textarea" :state="chkState('texto')" placeholder="Descrição" v-model="$v.form.texto.$model" rows="3" max-rows="6"></b-form-textarea>
                 <b-form-invalid-feedback id="input1LiveFeedback1">Descrição é obrigatório.</b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                   <br>
                                        <b-form-group label="Arquivo ou Link:">
                                            <b-form-radio-group v-model="selecao"
                                                                :options="decisao"
                                                                name="radio-inline"></b-form-radio-group>
                                        </b-form-group>
                                    </b-col>
            </b-row>
          <b-row v-if="selecao === 'A'">
             <b-col cols="12">
                 <label>Selecionar Arquivo: *</label>
                    <span class="icon-info" v-b-popover.hover.top="'Permitidos apenas Doc, Xls, PDF, PNG, JPG, Vídeo.'" title="Informação"></span>
                  <b-form-group label-for="nome-input" invalid-feedback="Identidade (RG) é obrigatório">
                     <b-form-file browse-text="Selecione" placeholder="Selecione o documento" accept="image/jpeg, image/png, image/gif" v-on:change="uploadDoc" :state="chkState('imagem')"></b-form-file>
                     <b-form-invalid-feedback id="input1LiveFeedback3">Imagem é obrigatório.</b-form-invalid-feedback>
                  </b-form-group>
              </b-col>
              <b-col v-if="documentoAtual" cols="12">
                    <a class="btn btn-sm btn-secondary action" title="Visualizar" @click="abrirDocumento(documentoAtual)">
                        Visualizar Arquivo Atual <i class="fa fa-eye">&nbsp;</i>
                     </a>
             </b-col>
            </b-row>
             <b-row v-if="selecao === 'L'">
              <b-col cols="12">
                <b-form-group label="Link: *">
                  <b-input-group class="mb-6">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="URL"
                                  autocomplete="link"
                                  v-model="$v.form.link.$model"
                                  :state="chkState('link')"
                                  />
                    <b-form-invalid-feedback id="input1LiveFeedback1">Link é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
         <b-card-footer class="p-12">
          <b-row>
            <b-col md="3" offset-md="3">
              <b-button block variant="primary" v-on:click="onSubmit">
                <i class="fa fa-check"></i>&nbsp;
                <span>Salvar Conteúdo</span>
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="secondary" @click="$router.go(-1)">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
    </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, requiredIf} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

const formShape = {
  titulo: '',
  texto: '',
  imagem: '',
  link: ''
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      texto: {
        required
      },
      link: {
        required: requiredIf(function (nestedModel) {
          console.log(this.selecao)
          if (this.selecao === 'L') {
            return !nestedModel.link
          }
        })
      },
      imagem: {
        required: requiredIf(function (nestedModel) {
          if (this.selecao === 'A') {
            return !this.documentoAtual
          }
        })
      }
    }
  },
  data () {
    return {
      form: Object.assign({}, formShape),
      id: 0,
      documentoAtual: false,
      descricaoValid: null,
      selecao: 'A',
      decisao: [
        {text: 'Arquivo', value: 'A'},
        {text: 'Link', value: 'L'}
      ]
    }
  },
  mounted () {
    if (typeof this.$route.params.id !== 'undefined') {
      this.loadNoticia(this.$route.params.id)
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    abrirDocumento (item) {
      window.open(item, '_blank')
    },
    salvar () {
      let form = this.$v.form

      let data = {
        id: this.id,
        documento: form.imagem.$model,
        texto: form.texto.$model,
        titulo: form.titulo.$model,
        link: form.link.$model,
        selecao: this.selecao,
        usuario_id: parseInt(SessionStorage.get('usuario'))
      }

      Vue.http.post('api/conteudo', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          if (this.cadastroInterno) {
            miniToastr.success('Conteúdo salva com sucesso!', 'Sucesso!', 7000)
          } else {
            miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          }

          this.$router.push({path: '/conteudos'})
        } else {
          this.disable_buttons = false
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    loadNoticia (id) {
      Vue.http.get('api/conteudo/' + id).then(response => {
        this.form.titulo = response.body.data.titulo
        this.form.texto = response.body.data.texto
        this.form.link = response.body.data.link
        this.documentoAtual = response.body.data.documento
        this.id = response.body.data.id

        if (response.body.data.link) {
          this.selecao = 'L'
        } else {
          this.selecao = 'A'
        }
      })
    },
    uploadDoc (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if ((arquivo[0].size / 1024 / 1024) > 1) {
        // miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        // miniToastr.error('Tamanho máximo permitido para o arquivo é 15Mb.', 'Alerta', 5000)
        // return false
      }

      let extensionesPermitidas = ['doc', 'xls', 'png', 'pdf', 'jpg']
      let ext = arquivo[0].name.split('.').pop()
      let permitida = false

      for (var i = 0; i < extensionesPermitidas.length; i++) {
        if (extensionesPermitidas[i] === ext) {
          permitida = true
          break
        }
      }

      if (!permitida) {
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Tipo de arquivo não permitido', 'Alerta', 5000)
        return false
      }

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.$v.form.imagem.$model = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    validaForm () {
      let valid = true

      if (this.$v.form.texto.$model === '') {
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Campo texto é obrigatorio.', 'Alerta!', 5000)
        this.descricaoValid = false
        valid = false
      } else {
        this.descricaoValid = true
      }

      return valid
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      if (this.validate() && this.validaForm()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
    img.preview {
        width: 200px;
        background-color: white;
        border: 1px solid #DDD;
        padding: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/conteudos/ConteudoForm.vue